function initialState() {
  return {
    uploads: {},
  }
}

let state = initialState()

export { initialState, state }
